import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { Product, ProductSearchRequest } from "../models/product";
import { AppConstants } from "../app_setting/app-constants";

@Injectable({
  providedIn: "root",
})
export class ProductService extends BaseService {
  getHomeProducts(
    lim: any,
    off: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`/product/home?lim=${lim}&off=${off}`).subscribe(
      (resp) => {
        onSuccess(resp.data);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  publicGetProductQueryParam(param: ProductSearchRequest): string {
    let apiUrl = `product?lim=${param.lim}&off=${param.off}`;

    if (param.src !== null && param.src !== "" && param.src !== undefined) {
      apiUrl += `&src=${param.src}`;
    }
    if (
      param.class1 !== null &&
      param.class1 !== "" &&
      param.class1 !== undefined
    ) {
      apiUrl += `&class1=${param.class1}`;
    }
    if (
      param.class2 !== null &&
      param.class2 !== "" &&
      param.class2 !== undefined
    ) {
      apiUrl += `&class2=${param.class2}`;
    }
    if (
      param.class3 !== null &&
      param.class3 !== "" &&
      param.class3 !== undefined
    ) {
      apiUrl += `&class3=${param.class3}`;
    }
    if (
      param.class4 !== null &&
      param.class4 !== "" &&
      param.class4 !== undefined
    ) {
      apiUrl += `&class4=${param.class4}`;
    }

    if (
      param.principal !== null &&
      param.principal !== undefined &&
      param.principal.length > 0
    ) {
      for (const item of param.principal) {
        if (item.code === undefined) {
          apiUrl += `&principal=${item}`;
        } else {
          apiUrl += `&principal=${item.code}`;
        }
      }
    }

    return apiUrl;
  }

  getProducts(
    param: ProductSearchRequest,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const apiUrl = this.publicGetProductQueryParam(param);
    this.get(apiUrl).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProductPlain(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get("/product/plain").subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProductStock(
    code: string,
    uom: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`/product/stock?code=${code}&uom=${uom}`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProductPrice(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get("/product/price").subscribe(
      (resp) => {
        onSuccess(resp.data);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProductSearchHistory(
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get("/product/search_history").subscribe(
      (resp) => {
        onSuccess(resp.data);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  uploadExcel(
    file: File,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const formData = new FormData();
    formData.append("excelFile", file);

    this.postMultipartFormData("cart/upload_excel", formData).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  public updateQuantity(type: boolean, product: Product): void {
    if (product === null) {
      return;
    }
    if (type) {
      if (product.ref_quantity < 9999) {
        product.ref_quantity += 1;
      }
    } else {
      if (product.ref_quantity > 1) {
        product.ref_quantity -= 1;
      }
    }
  }

  public insertQuantity(number: number, product: Product): void {
    product.ref_quantity = number;
  }

  public ResolveProductImage(imageUrl: string): string {
    if (imageUrl === null || imageUrl === "" || imageUrl === undefined) {
      return AppConstants.ProductImageDefault;
    }

    return imageUrl;
  }

  getTemplate(onSuccess: (data) => void, onError: (data) => void = null): any {
    this.getFile("/v2/cart/download_template").subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getProductDetail(
    productCode: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(`product/Get_Detail_Product?CodeProduct=${productCode}`).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getPrincipalDetail(
    principalCode: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `principal/Get_Detail_Principal?PrincipalCode=${principalCode}`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  //CR10
  getProductsPromo(
    param: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.postPromo('promos/get-promo', param).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  getPriceProduct(
    productCode: string,
    unitOfMeasure: string,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.get(
      `product/price?productCode=${productCode}&unitOfMeasure=${unitOfMeasure}`
    ).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }

  // CR-15
  getExpireDateProduct(
    listProduct: any,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    this.post('exdate', listProduct).subscribe(
      (resp) => {
        onSuccess(resp.data);
      },
      (err) => {
        if (onError) {
          onError(err);
        }
      }
    );
  }
}
